import { StyledButton } from '@tmh-website/ui/Button';
import styled from 'styled-components';

export const FormContainer = styled.div`
  ${StyledButton.ButtonContainer} {
    width: 100%;
    ${StyledButton.Button} {
      width: 100%;
      margin: 0;
    }
  }
`;
